import styled from 'styled-components'

export const RadiusFilterBar = styled.div`
  padding: 16px 0px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  margin-bottom: 20px;
`

export const RadiusFilters = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`

export const RadiusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  color: ${({ theme }) => theme.colors.text.primary};
  border-radius: 12px;
  font-size: 10px;
  font-weight: 500;

  svg {
    width: 10px;
    height: 10px;
  }
`
